import { AVATAR_TYPES } from '../Constants';
import { isType } from '../types/SharedPropTypes';
export function makeLookupObject({
  companyId,
  domain,
  email,
  fileManagerKey,
  hubSpotUserEmail,
  productId,
  type,
  vid,
  primaryIdentifier,
  secondaryIdentifier
}) {
  if (primaryIdentifier && secondaryIdentifier && type) {
    return {
      type,
      primaryIdentifier,
      secondaryIdentifier
    };
  }
  if (type && primaryIdentifier) {
    return {
      type,
      primaryIdentifier
    };
  }

  // quickest BE response…probably
  if (vid && email && fileManagerKey) {
    return {
      type: 'contact',
      primaryIdentifier: vid,
      secondaryIdentifier: email,
      fileManagerKey
    };
  }
  if (vid && email) {
    return {
      type: 'vid',
      primaryIdentifier: vid,
      secondaryIdentifier: email
    };
  }

  // quickest BE response…probably
  if (companyId && domain && fileManagerKey) {
    return {
      type: 'company',
      primaryIdentifier: companyId,
      secondaryIdentifier: domain,
      fileManagerKey
    };
  }

  // If we have type
  if (type === 'enrichmentDomain') {
    return primaryIdentifier || domain ? {
      type,
      primaryIdentifier: primaryIdentifier || domain
    } : {};
  }
  const [selfieType, selfiePrimaryIdentifier] = [['companyId', companyId], ['domain', domain], ['email', email], ['hubSpotUserEmail', hubSpotUserEmail], ['productId', productId], ['vid', vid]].filter(([__type, value]) => !!value)[0] || [];
  if (Object.keys(AVATAR_TYPES).filter(t => t === type).length > 0 && selfiePrimaryIdentifier) {
    return {
      type,
      primaryIdentifier: selfiePrimaryIdentifier
    };
  }
  if (isType(selfieType) && selfiePrimaryIdentifier) {
    return {
      type: selfieType,
      primaryIdentifier: selfiePrimaryIdentifier
    };
  }
  return {};
}